import React, { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  LoadSecureLogin,
  secureLoginSelector,
} from "../features/secureLogin/secureLoginSlice";
import { authLoginSelector } from "../features/auth/authLoginSlice";
import { getFileNumberfromFileID } from "../common/utils";
import { GetFirmByFileID } from "../features/lawFirm/lawFirmSlice";
import { GetFileSummaryExpress } from "../features/orders/orderSlice";

const useSecureLogin = () => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { loading, errorMessage, prosuiteDetails, isFileOpenedfromTT, TTFileID } =
    useSelector(secureLoginSelector);

  const { userLogin } = useSelector(authLoginSelector);

  useEffect(() => {
    dispatch(LoadSecureLogin(searchParams.get("data"), searchParams.get("isOpenedFromTT")));
  }, []);

  useEffect(() => {
    if (prosuiteDetails?.fileID > 0 && errorMessage === null) {
      let fileID = parseInt(prosuiteDetails?.fileID);
      navigate(`/order/${fileID}`);
    }
  }, [prosuiteDetails]);

  useEffect(() => {
    if (userLogin != null && userLogin?.result && isFileOpenedfromTT === true && TTFileID !== undefined && TTFileID !== 0) {
      let fileID = parseInt(TTFileID);
      window.localStorage.setItem(
        "isFileOpenedfromTT",
        "true"
      );
      window.localStorage.setItem(
        "TTFileID",
        TTFileID
      );


      dispatch(GetFirmByFileID(fileID, userLogin?.userId));
      dispatch(GetFileSummaryExpress(fileID, userLogin?.userId));
      navigate(`/ordersummary/${getFileNumberfromFileID(fileID)}`);
    }
  }, [userLogin, isFileOpenedfromTT, TTFileID]);

  return {
    errorMessage,
    prosuiteDetails,
    t,
    loading,
  };
};

export default useSecureLogin;